import React, { ReactNode } from 'react';
import { Head as InertiaHead } from '@inertiajs/react';

interface HeadProps {
    title: string;
    children?: ReactNode;
}

export const Head: React.FC<HeadProps> = ({ title, children }) => {
    return (
        <InertiaHead>
            <title>{title}</title>
            <meta property="og:title" content={title || 'ReelFlow Dashboard'} />
            {children}
        </InertiaHead>
    );
};
